import ValidationType from '../ValidationType';
import { numberIsGreaterThan, numbersAreEqual } from "../../util";

class GreaterThanEqualValue extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const current = fieldResponse.currentValue;
      const compare = validation.value;
      if (!numberIsGreaterThan(current, compare) && !numbersAreEqual(current, compare)) {
        let validation_value = validation.value;
        if (fieldResponse.fieldInstance.field.fieldType.defined_as == "FIELD_DURATION"){
          validation_value = validation.value + " minutes";
        }
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_GREATER_THAN_OR_EQUAL_TO_SPECIFIED_VALUE',
          values: { value: validation_value },
          message: `Value should be greater than or equal to '${validation_value}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default GreaterThanEqualValue;
